import React from "react";
import Button from "../Button";
import { DoodleHeart } from "../brand";

const Aboutus = () => {
  return (
    <section
      className="bg-surface-light py-16 md:py-24 text-left border-y border-mist-hair w-full"
      id="about"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-14 items-center">
          <div className="lg:col-span-5 relative">
            <DoodleHeart
              className="absolute -top-4 -left-4 z-20 pointer-events-none"
              size={34}
            />
            <div className="overflow-hidden rounded-brand shadow-brand-md border border-cloud-mist bg-surface-white relative">
              <img
                src={
                  process.env.PUBLIC_URL + "/images/photos/about-caregiver-child.webp"
                }
                alt="Caregiver and child laughing while building with wooden blocks at home"
                className="w-full h-[360px] sm:h-[400px] object-cover rounded-brand"
                onError={(e) => {
                  e.target.src =
                    process.env.PUBLIC_URL +
                    "/images/ourstoryhero/mission&vision.webp";
                }}
              />
              <div className="absolute bottom-4 left-4 bg-white-chip backdrop-blur-sm px-4 py-2.5 rounded-brand border border-cloud-mist shadow-brand-sm flex items-center gap-2.5">
                <div className="w-3 h-3 rounded-full bg-heart-teal" aria-hidden="true" />
                <span className="text-xs font-semibold text-ink font-headline">
                  Built with Heart & Lived Experience
                </span>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 flex flex-col items-start text-left">
            <span className="inline-block bg-cloud-mist text-spectrum-blue text-xs font-bold tracking-wider px-3.5 py-1 rounded-brand mb-3 font-headline">
              About Us
            </span>
            <h2 className="font-headline text-3xl md:text-4xl text-ink leading-tight mb-5">
              <span className="font-light">Built for Caregivers,</span>
              <span className="font-extrabold text-spectrum-blue block sm:inline">
                {" "}
                by a Caregiver
              </span>
            </h2>
            <p className="font-body text-muted text-[15px] md:text-[16px] leading-relaxed max-w-[560px] mb-4">
              Born from lived experience, Social Spectrum is a community-driven
              platform designed to empower families navigating neurodivergence.
              We understand the journey because we&apos;ve lived it.
            </p>
            <p className="font-body text-muted text-[15px] md:text-[16px] leading-relaxed max-w-[560px] mb-8">
              Our platform brings together expert resources, compassionate
              community support, and innovative tools to help every family feel
              seen, supported, and celebrated.
            </p>
            <Button to="/ourstory" variant="primary" size="md">
              Read Our Story →
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Aboutus;
